import React, { useEffect, useRef } from "react";

/**
 * Ember particles – atmospheric, NOT video-game style.
 * Renders a small set of glowing embers rising from bottom.
 * variant: "default" (orange, for dark bg) | "light" (saturated red, for white/light bg)
 */
export default function Embers({ count = 18, variant = "default", className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    const container = ref.current;
    container.innerHTML = "";
    const isLight = variant === "light";
    for (let i = 0; i < count; i++) {
      const e = document.createElement("span");
      e.className = isLight ? "ember ember-light" : "ember";
      const size = isLight ? 4 + Math.random() * 5 : 2 + Math.random() * 4;
      e.style.width = `${size}px`;
      e.style.height = `${size}px`;
      e.style.left = `${Math.random() * 100}%`;
      e.style.bottom = `${-10 - Math.random() * 30}px`;
      const dur = 5 + Math.random() * 6;
      const delay = Math.random() * 8;
      const anim = Math.random() > 0.5 ? "ember-rise" : "ember-rise-2";
      e.style.animation = `${anim} ${dur}s ease-out ${delay}s infinite, flicker 1.4s ease-in-out infinite`;
      e.style.opacity = "0";
      container.appendChild(e);
    }
  }, [count, variant]);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    />
  );
}
